
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1920","height":"119","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1921.25 118.723c-.51-.244-12.76-6.067-36.47-14.666-14.09-5.108-29.37-10.166-45.43-15.034-20.07-6.082-41.4-11.88-63.42-17.233-56.02-13.625-116.7-24.481-180.35-32.267-37.78-4.623-77.05-8.2-116.71-10.634-43.63-2.676-88.8-4.033-134.28-4.033-29.05 0-58.85.555-88.56 1.65-31.12 1.145-63 2.915-94.76 5.258a2768.836 2768.836 0 00-100.95 9.34c-35.22 3.9-71.256 8.578-107.118 13.89-62.221 9.216-124.164 17.27-184.108 23.94-55.614 6.186-110.866 11.333-164.222 15.299-49.029 3.642-97.609 6.371-144.389 8.111-42.451 1.58-84.376 2.381-124.609 2.381-51.232 0-100.771-1.291-147.238-3.838-37.173-2.038-72.476-4.879-104.928-8.445-28.87-3.172-50.092-6.344-62.813-8.446C7.36 81.76.295 80.222.003 80.157V29.468C27.055 33.4 84.52 40.996 165.447 47.679c45.383 3.748 92.118 6.7 138.908 8.773a3820.531 3820.531 0 00168.388 3.729c173.292 0 342.276-11.858 502.256-35.243a1712.943 1712.943 0 0177.571-11.162c25.14-3.035 50.91-5.582 76.6-7.569 24.74-1.915 50.06-3.363 75.26-4.3 24.23-.9 48.99-1.362 73.59-1.362 37.68 0 76.24 1.073 114.59 3.19 35.62 1.966 71.89 4.876 107.8 8.651 63.46 6.67 127.14 16.143 189.26 28.156 26.58 5.141 52.99 10.774 78.49 16.742 22.68 5.309 44.8 10.92 65.75 16.676 18.42 5.06 35.75 10.184 51.53 15.228 13.67 4.371 26.05 8.658 35.82 12.4v17.141l-.01-.006z","fill":"#FEDF40"}})])
          )
        }
      }
    